<template>

  <div>
    <div
      v-for="n in count"
      :key="n"
      class="d-flex align-items-center"
      :class="slim ? 'justify-content-center py-1' : 'p-3 border-bottom'">
      <div
        class="skeleton rounded-circle"
        :class="slim ? 'skeleton-circle-slim' : 'skeleton-circle mr-3'"></div>
      <div
        v-if="!slim"
        class="flex-grow-1">
        <div class="skeleton w-50 mb-2"></div>
        <div class="skeleton w-75"></div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'ConversationListSkeleton',
  props: {
    count: {
      type: Number,
      default: 8
    },
    slim: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
/* pulsing grey placeholders shown while the list is loading */
.skeleton {
  height: 10px;
  background: #e9ecef;
  border-radius: 4px;
  animation: skeleton-pulse 1.4s ease-in-out infinite;
}

.skeleton-circle {
  flex: 0 0 auto;
  width: 44px;
  height: 44px;
}

.skeleton-circle-slim {
  flex: 0 0 auto;
  width: 36px;
  height: 36px;
}

@keyframes skeleton-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
}
</style>



// WEBPACK FOOTER //
// src/components/Messaging/sidebar/ConversationListSkeleton.vue